import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, useTheme } from '@mui/material';
import React from 'react';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

function getStyles(value, selectedValue, theme) {
  return {
    fontWeight: selectedValue.indexOf(value) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium
  };
}

const CusMultipleSelect = ({ id = 'demo-multiple-name', label = 'label', options = [], placeholder, field }) => {
  const theme = useTheme();
  const [selectedValue, setSelectedValue] = React.useState([]);
  const handleChange = (event) => {
    const {
      target: { value }
    } = event;
    const arrValue = typeof value === 'string' ? value.split(',') : value;

    setSelectedValue(arrValue);
    field?.onChange(arrValue);
  };
  return (
    <div>
      <FormControl sx={{ width: 200 }}>
        <InputLabel id={`${id}-label`}>{label}</InputLabel>
        <Select
          labelId={`${id}-label`}
          id={id}
          multiple
          value={selectedValue}
          onChange={handleChange}
          onBlur={field?.onBlur}
          input={<OutlinedInput label={placeholder} />}
          MenuProps={MenuProps}
        >
          {options.map(({ label, value }) => (
            <MenuItem key={label} value={value} style={getStyles(value, selectedValue, theme)}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default CusMultipleSelect;
